import ReactLightbox from 'react-image-lightbox'

import { zIndex } from '@/styles'

import LightboxStyles from './styles'

import 'react-image-lightbox/style.css'

const Lightbox = ({ isOpen, reactModalStyle, ...rest }) =>
  isOpen ? (
    <>
      <ReactLightbox
        reactModalStyle={{
          overlay: { zIndex: zIndex.modal },
          ...reactModalStyle
        }}
        {...rest}
      />
      <LightboxStyles />
    </>
  ) : null

export default Lightbox
